import $ from 'jquery';
import 'slick-carousel';
import debounce from '../../utils/debounce';

const carouselWhyUsCandidate = () => {
	const el = {
		target: '.mi-carousel__whyUsCandidate',
	};

	let isInitialized = false;

	const init = () => {
		$(function () {
			if (!$(el.target).length) return;

			exec();

			$(window).on(
				'resize',
				debounce(function () {
					if (window.innerWidth < 601 && !isInitialized) exec();
					else isInitialized = false;
				}, 150),
			);
		});
	};

	const exec = () => {
		const $target = $(el.target);

		$target.on('init', function (slick) {
			isInitialized = true;
		});

		$target.slick({
			mobileFirst: true,
			slidesToShow: 1,
			slidesPerRow: 1,
			rows: 2,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 600,
					settings: 'unslick',
				},
			],
		});
	};

	init();
};

try {
	carouselWhyUsCandidate();
} catch (error) {
	console.error(error);
}
